import React from 'react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

interface AccountNumberInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
}

export default function AccountNumberInput({ value, onChange, disabled }: AccountNumberInputProps) {
  const { t } = useTranslation();

  return (
    <TextField
      label={t('formInputs.accountNumberInputLabel')}
      variant='outlined'
      fullWidth
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    />
  );
}
